const n = {trigger: '[data-accordion-trigger]', panel: '[data-accordion-panel]'};
class r extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {triggers: this.querySelectorAll(n.trigger), panels: this.querySelectorAll(n.panel)}),
      this.addEventListener('click', this.handleClick.bind(this)),
      this.initPanels(),
      this.observePanelHeight();
  }
  disconnectedCallback() {
    this.heightObserver.disconnect();
  }
  initPanels() {
    this.elements.panels.forEach((e) => {
      e.classList.contains('show-panel') && (e.style.height = `${e.scrollHeight}px`);
    });
  }
  observePanelHeight() {
    const e = this.querySelector(n.panel);
    if (!e) return;
    const t = () => {
      e.classList.contains('show-panel') && ((e.style.height = 'auto'), (e.style.height = `${e.scrollHeight}px`));
    };
    window.addEventListener('resize', t),
      (this.heightObserver = new MutationObserver(t)),
      this.heightObserver.observe(e, {childList: !0, subtree: !0});
  }
  handleClick(e) {
    const t = e.target.closest(n.trigger);
    if (!t) return;
    const s = t.getAttribute('aria-controls'),
      i = this.querySelector(`#${s}`);
    t.getAttribute('aria-multi') === '1' || this.closeAllPanels(t, i), this.togglePanel(t, i);
  }
  closeAllPanels(e, t) {
    this.elements.triggers.forEach((s) => {
      s !== e && s.setAttribute('aria-expanded', 'false');
    }),
      this.elements.panels.forEach((s) => {
        s !== t && (s.style.height = '0');
      });
  }
  togglePanel(e, t) {
    const s = e.getAttribute('aria-expanded') === 'true',
      i = s ? '0' : `${t.scrollHeight}px`;
    e.setAttribute('aria-expanded', (!s).toString()), (t.style.height = i);
  }
}
function o() {
  customElements.define('component-accordion', r);
}
export {o as i};
